// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ConversationPreview_conversation-item__v6uyU {
  width: 100%;
  display: grid;
  grid-template-columns: 80px 100%;
  height: 80px;
  border-bottom: 1px solid #ccc;
  color: black;
  padding: 10px 0;
}
.ConversationPreview_conversation-item__v6uyU .ConversationPreview_profile-picture-container__XXDk1 {
  display: flex;
  align-items: center;
  justify-content: center;
}
.ConversationPreview_conversation-item__v6uyU .ConversationPreview_conversation-details__t4DU- {
  width: calc(100% - 80px);
  display: grid;
  height: 100%;
  grid-template-rows: 30px 30px;
  grid-template-columns: 100%;
  padding: 0 20px 0 10px;
}
.ConversationPreview_conversation-item__v6uyU .ConversationPreview_conversation-details__t4DU- .ConversationPreview_upper-details__9fwgC,
.ConversationPreview_conversation-item__v6uyU .ConversationPreview_conversation-details__t4DU- .ConversationPreview_lower-details__QfOWx {
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
}
.ConversationPreview_conversation-item__v6uyU .ConversationPreview_conversation-details__t4DU- .ConversationPreview_user-name__Wtor7,
.ConversationPreview_conversation-item__v6uyU .ConversationPreview_conversation-details__t4DU- .ConversationPreview_time__9ELMp,
.ConversationPreview_conversation-item__v6uyU .ConversationPreview_conversation-details__t4DU- .ConversationPreview_message-text__Ntu4B,
.ConversationPreview_conversation-item__v6uyU .ConversationPreview_conversation-details__t4DU- .ConversationPreview_unseen-messages-count__pc3Kh {
  height: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  text-decoration: none;
}
.ConversationPreview_conversation-item__v6uyU .ConversationPreview_conversation-details__t4DU- .ConversationPreview_upper-details__9fwgC {
  font-weight: 700;
}
.ConversationPreview_conversation-item__v6uyU .ConversationPreview_conversation-details__t4DU- .ConversationPreview_upper-details__9fwgC .ConversationPreview_user-name__Wtor7 {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  margin-right: 5px;
}
.ConversationPreview_conversation-item__v6uyU .ConversationPreview_conversation-details__t4DU- .ConversationPreview_upper-details__9fwgC .ConversationPreview_time__9ELMp {
  color: rgb(90, 90, 90);
  margin-left: 5px;
  font-size: 0.8em;
}
.ConversationPreview_conversation-item__v6uyU .ConversationPreview_conversation-details__t4DU- .ConversationPreview_lower-details__QfOWx .ConversationPreview_message-text__Ntu4B {
  color: #666;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  font-weight: 500;
}
.ConversationPreview_conversation-item__v6uyU .ConversationPreview_conversation-details__t4DU- .ConversationPreview_lower-details__QfOWx .ConversationPreview_unseen__fdlHR {
  color: var(--accent-color);
  font-weight: 700;
}`, "",{"version":3,"sources":["webpack://./src/Pages/Messages/ConversationPreview/ConversationPreview.module.scss"],"names":[],"mappings":"AAAA;EACI,WAAA;EACA,aAAA;EACA,gCAAA;EACA,YAAA;EACA,6BAAA;EACA,YAAA;EACA,eAAA;AACJ;AACI;EACI,aAAA;EACA,mBAAA;EACA,uBAAA;AACR;AAGI;EACI,wBAAA;EACA,aAAA;EACA,YAAA;EACA,6BAAA;EACA,2BAAA;EACA,sBAAA;AADR;AAGQ;;EAEI,WAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,mBAAA;AADZ;AAIQ;;;;EAII,YAAA;EACA,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,qBAAA;AAFZ;AAKQ;EACI,gBAAA;AAHZ;AAKY;EACI,gBAAA;EACA,mBAAA;EACA,uBAAA;EACA,iBAAA;AAHhB;AAMY;EACI,sBAAA;EACA,gBAAA;EACA,gBAAA;AAJhB;AASY;EACI,WAAA;EACA,gBAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;AAPhB;AAUY;EACI,0BAAA;EACA,gBAAA;AARhB","sourcesContent":[".conversation-item {\n    width: 100%;\n    display: grid;\n    grid-template-columns: 80px 100%;\n    height: 80px;\n    border-bottom: 1px solid #ccc;\n    color: black;\n    padding: 10px 0;\n\n    .profile-picture-container {\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        // background-color: greenyellow;\n    }\n\n    .conversation-details {\n        width: calc(100% - 80px);\n        display: grid;\n        height: 100%;\n        grid-template-rows: 30px 30px;\n        grid-template-columns: 100%;\n        padding: 0 20px 0 10px;\n\n        .upper-details,\n        .lower-details {\n            width: 100%;\n            display: flex;\n            flex-direction: row;\n            justify-content: space-between;\n            align-items: center;\n        }\n\n        .user-name,\n        .time,\n        .message-text,\n        .unseen-messages-count {\n            height: 100%;\n            display: flex;\n            flex-direction: row;\n            align-items: center;\n            text-decoration: none;\n        }\n\n        .upper-details {\n            font-weight: 700;\n\n            .user-name {\n                overflow: hidden;\n                white-space: nowrap;\n                text-overflow: ellipsis;\n                margin-right: 5px;\n            }\n\n            .time {\n                color: rgb(90, 90, 90);\n                margin-left: 5px;\n                font-size: 0.8em;\n            }\n        }\n\n        .lower-details {\n            .message-text {\n                color: #666;\n                overflow: hidden;\n                white-space: nowrap;\n                text-overflow: ellipsis;\n                font-weight: 500;\n            }\n\n            .unseen {\n                color: var(--accent-color);\n                font-weight: 700;\n            }\n        }\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"conversation-item": `ConversationPreview_conversation-item__v6uyU`,
	"profile-picture-container": `ConversationPreview_profile-picture-container__XXDk1`,
	"conversation-details": `ConversationPreview_conversation-details__t4DU-`,
	"upper-details": `ConversationPreview_upper-details__9fwgC`,
	"lower-details": `ConversationPreview_lower-details__QfOWx`,
	"user-name": `ConversationPreview_user-name__Wtor7`,
	"time": `ConversationPreview_time__9ELMp`,
	"message-text": `ConversationPreview_message-text__Ntu4B`,
	"unseen-messages-count": `ConversationPreview_unseen-messages-count__pc3Kh`,
	"unseen": `ConversationPreview_unseen__fdlHR`
};
export default ___CSS_LOADER_EXPORT___;
